export const loadingGraphData = [
  {
    date: 0,
    test: 4000,
    bar: 10,
  },
  {
    date: 1,
    test: 3000,
    bar: 8,
  },
  {
    date: 2,
    test: 2000,
    bar: 6,
  },
  {
    date: 3,
    test: 2780,
    bar: 4,
  },
  {
    date: 4,
    test: 1890,
    bar: 2,
  },
  {
    date: 5,
    test: 2390,
    bar: 4,
  },
  {
    date: 6,
    test: 3490,
    bar: 12,
  },
];

export const stableGraphData = [
  {
    date: 0,
    test: 0,
  },
  {
    date: 2,
    test: 0,
  },
];
